<template>
    <div>
        <div id="dashboard_left">
            <div class="main_right col-12 pl-0 pr-0 d-flex">
                <!-- <div class="logo_blog"><img src="@/assets/logo.png" /></div> -->
                <div class="form_search" content="Tìm kiếm theo tên tác giả hoặc tên bài viết" v-tippy>
                    <div class="input-group">
                        <input type="text" class="shadow-none form-control input-search-article input-border-radius"
                            v-model="search.search_text" id="text_search" placeholder="Nhập tên tác giả hoặc bài viết">
                        <div class="input-group-prepend">
                            <div class="input-group-text div-border-radius"><i class="fa-solid fa-magnifying-glass"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" v-if="search.search_text != ''" id="list_search">
                <div class="col-12 p-1" id="inner_search">
                    <div v-if="search_user != [] || search_article != []" class="item_user_article">
                        <div v-if="search_user">
                            <div @click="this.$gotoHomePersonal(user.id)" v-for="(user, index) in search_user"
                                :key="index" class="item_user">
                                <img :src="user.avatar ? user.avatar : require('@/assets/avatar.jpg')"
                                    alt="Avatar User">
                                <span> {{ user.name }} </span>
                            </div>
                        </div>
                        <div v-if="search_article">
                            <div @click="gotoArticleDetail(article)" v-for="(article, index2) in search_article"
                                :key="index2" class="item_article">
                                <i class="fa-solid fa-blog" style="margin-right: 8px;"></i> {{ article.article_title }}
                            </div>
                        </div>
                    </div>
                    <div v-if="search_user.length == 0 && search_article.length == 0" class="no_result"><i
                            class="fa-solid fa-magnifying-glass"></i> Không kết quả !</div>
                </div>
            </div>
            <div class="container-list-user">
            <div class="list-user" v-if="search.search_text === '' && !isLoading && onlineUsers.length > 0">
                <div class="container-avatar">
                    <div @click="this.$gotoHomePersonal(record.user_id)" class="item-user" v-for="(record, index) in onlineUsers" :key="index">
                        <div class="img-user">
                            <img :src="record.avatar ? record.avatar : require('@/assets/avatar.jpg')">
                            <span class="user_online"></span>
                        </div>
                        <span class="goto-personal fullname-user"> {{ record.fullname }} </span>
                    </div>
                </div>
            </div>
            <div v-if="isLoading" class="d-flex justify-content-center container-loader">
                <flower-spinner class="loading-component" :animation-duration="2000" :size="30" color="#06C755" />
            </div>
            <!-- {{ Object.keys(this.statusData).length }} -->
            <!-- {{ onlineUsers.length }} -->
            <!-- Object.keys(this.statusData).length > onlineUsers.length && !isLoading -->
            <div class="d-flex justify-content-center" v-if="!isLoading && onlineUsers.length > 0">
                <button type="button" @click="changePage()" class="view-more btn btn-outline-secondary btn-sm">Xem
                    thêm</button>
            </div>
            </div>
        </div>
    </div>
</template>

<script>

import UserRequest from '@/restful/UserRequest';
import _ from 'lodash';
import { FlowerSpinner } from 'epic-spinners';
import { ref, onValue } from 'firebase/database';
import { realtimeDb } from '@/firebase';

export default {
    name: "HomePublicLeft",
    props: {

    },
    components: {
        FlowerSpinner,
    },
    data() {
        return {
            search_user: [],
            search_article: [],
            onlineUsers: [],
            page: 1,
            per_page: 10,
            isLoading: false,
            statusData: {}, // Dữ liệu trạng thái từ Realtime Database
            search: {
                search_text: '',
            },
        }
    },
    created() {
        this.listenToOnlineStatus();
    },
    mounted() {
        // this.getOnlines();
    },
    methods: {
        gotoArticleDetail: function (record) {
            this.$router.push({ name: 'HomeArticleDetail', params: { slug_name_article: record.article_slug + '-id-record-' + record.id } });
        },
        getDataRecords: async function () {
            this.isLoading = true;
            try {
                const { data } = await UserRequest.get(`home/search-author-or-article?&search_text=${this.search.search_text}`)
                this.search_user = data.search_user;
                this.search_article = data.search_article;
                this.isLoading = false;
            }
            catch (error) {
                if (error.messages) this.$emitEvent('eventError', error.messages[0]);
                this.isLoading = false;
            }
        },
        async listenToOnlineStatus() {
            const statusRef = ref(realtimeDb, '/status'); // Lắng nghe toàn bộ node /status
            onValue(statusRef, (snapshot) => {
                this.statusData = snapshot.val() || {};
                this.page = 1;
                this.onlineUsers = [];
                this.getOnlines();
            }, (error) => {
                console.error('Error listening to /status:', error);
            });
        },
        getOnlines: async function () {
            this.isLoading = true;
            try {
                const { data } = await UserRequest.post(`user-online?page=${this.page}&per_page=${this.per_page}&user_status=online`, { status_data: this.statusData });
                this.onlineUsers = [...this.onlineUsers, ...data.data];

                // Loại bỏ người dùng trùng lặp dựa trên ID
                this.onlineUsers = this.onlineUsers.filter(
                    (user, index, self) =>
                        index === self.findIndex((u) => u.user_id === user.user_id)
                );
            } catch (error) {
                if (error.messages) this.$emitEvent('eventError', error.messages[0]);
                this.onlineUsers = [];
            }
            this.isLoading = false;
        },
        changePage: function () {
            this.page++;
            this.getOnlines();
        },

    },
    watch: {
        search: {
            handler: _.debounce(function () {
                this.getDataRecords();
            }, 500),
            deep: true,
        },
    }
}
</script>
<style scoped src="./homepublicleft-responsive.css"></style>
<style scoped src="@/components/home/home-public/left.css"></style>
<style scoped></style>